import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useGoogleAuth } from "./hooks/useGoogleAuth";

const AdsCreatorRoute = ({ children }) => {
  const token = localStorage.getItem("authToken");
  const { user, initializing, login, error } = useGoogleAuth();
  const [attempted, setAttempted] = useState(false);

  useEffect(() => {
    if (token || initializing || user || attempted) return;
    setAttempted(true);
    login({ forceRedirect: true }).catch(() => {
      setAttempted(false);
    });
  }, [token, initializing, user, attempted, login]);

  if (token || user) {
    return children;
  }

  return (
    <Gate>
      <GateCard>
        <h3>Hold up ✋</h3>
        <p>Sign in with your Gmail account to upload an ad.</p>
        <GateButton onClick={() => login()}>
          Continue with Google
        </GateButton>
        {error && (
          <GateError>Google login failed. Please retry or refresh.</GateError>
        )}
      </GateCard>
    </Gate>
  );
};

const Gate = styled.div`
  min-height: 100vh;
  background: #050507;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
`;

const GateCard = styled.div`
  background: #15151f;
  padding: 32px;
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  text-align: center;
  color: #fff;
  max-width: 360px;
  width: 100%;

  h3 {
    margin-bottom: 10px;
    font-size: 24px;
  }

  p {
    color: #9b9bbb;
    margin-bottom: 20px;
  }
`;

const GateButton = styled.button`
  width: 100%;
  padding: 12px;
  border-radius: 14px;
  border: none;
  background: linear-gradient(135deg, #6c5ce7, #7c7cff);
  color: #fff;
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 12px;
`;

const GateError = styled.p`
  color: #ff9db1;
  font-size: 14px;
  margin: 0;
`;

export default AdsCreatorRoute;

